import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const markDirectMessageNotificationsSeenMutation = gql`
  mutation markDirectMessageNotificationsSeen {
    markDirectMessageNotificationsSeen
  }
`;

const markDirectMessageNotificationsSeenOptions = {
  props: ({ mutate }) => ({
    markDirectMessageNotificationsSeen: () => mutate(),
  }),
};

export default graphql(
  markDirectMessageNotificationsSeenMutation,
  markDirectMessageNotificationsSeenOptions
);
